import {Button, Card, Col, Divider, Form, Input, message, Modal, Row, Space, Spin, Table, Tag, Tooltip} from "antd";
import {DownloadOutlined, ExclamationCircleOutlined, EyeOutlined, RedoOutlined, StopOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
import {
    API_RESPONSE_STATUS,
    DOC_CODE_INVEST_TRANSACTION_DOCUMENT,
    NOT_AVAILABLE,
    PREVIEW_DOC_TYPES, YYYY_MM_DD,
    YYYY_MM_DD_HH_MM
} from "../../../util/Constants";
import {AccountWiseFundDetailWrapperDto} from "../../../dto/AccountWiseFundDetailWrapperDto";
import TableSearchComp from "../../../components/common/tableSearch/TableSearchComp";
import transactionFetchService from "../../../service/transactionFetchService";
import {MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR, MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR} from "../../../util/Messages";
import {AccountWiseFundDetailDto} from "../../../dto/AccountWiseFundDetailDto";
import ErrorHandler from "../../../util/ErrorHandler";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import documentService from "../../../service/documentService";
import modal from "antd/es/modal";
import transactionService from "../../../service/transactionService";
import {AuthorizeTransactionDto} from "../../../dto/AuthorizeTransactionDto";
import TextArea from "antd/es/input/TextArea";
import PreviewModalComp from "../../../components/common/preview/PreviewModalComp";
import Validation from "../../../util/Validation";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope, faMoneyBillTransfer} from "@fortawesome/free-solid-svg-icons";


const InvestRetryRequestList = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSpinnerLoading, setSpinnerLoading] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [investMoneyRequestDocument, setInvestMoneyRequestDocument] = useState<UploadedDocumentDetailDto>();

    const [customerRequestList, setCustomerRequestList] = useState<AccountWiseFundDetailDto[]>([]);
    const [investForm] = Form.useForm()
    const [apiResponseStatus, setApiResponseStatus] = useState<string | null>(null);
    const [docURL, setDocURL] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [documentName, setDocumentName] = useState<string>("");
    const [isRejectReasonModalOpen, setRejectReasonModalOpen] = useState(false);
    const [modalData, setModalData] = useState<AccountWiseFundDetailWrapperDto>({
        requestId: 0,
        cin: "",
        portFolioNumber: "",
        portFolioId: 0,
        customerName: "",
        requestedDate: "",
        accountType: "",
        transactionTag: "",
        requestList: []
    });
    useEffect(() => {
        fetchProcessingInvestRequests()
    }, [])

    const fetchProcessingInvestRequests = () => {
        setSpinnerLoading(true)
        transactionFetchService.getProcessingInvestCustomerRequests().then(res => {
            if (res.data !== null) {
                setCustomerRequestList(res.data.results)
                setSpinnerLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR).then();
                setSpinnerLoading(false)
            }

        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinnerLoading(false)
        })
    }

    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }

    const handlePreviewCancel = () => {
        investForm.resetFields()
        setPreviewOpen(false);
    };

    const handleRejectReasonCancel = () => {
        setRejectReasonModalOpen(false)
        setLoading(false)
    }

    let columns = [
        {
            title: 'Request ID',
            dataIndex: 'accountWiseFundId',
            key: 'accountWiseFundId',
            sorter: (a: any, b: any) => (a.accountWiseFundId - b.accountWiseFundId),
            ...TableSearchComp('accountWiseFundId', 'Request ID'),
        },
        {
            title: 'CIN',
            dataIndex: 'customerCin',
            key: 'customerCin',
            sorter: (a: any, b: any) => (a.customerCin - b.customerCin),
            ...TableSearchComp('customerCin', 'CIN'),
        },
        {
            title: 'Portfolio ID',
            dataIndex: 'portfolioNumber',
            key: 'portfolioNumber',
            sorter: (a: any, b: any) => (a.portfolioNumber - b.portfolioNumber),
            ...TableSearchComp('portfolioNumber', 'Portfolio ID'),
        },
        {
            title: 'Customer Name',
            dataIndex: 'customerName',
            key: 'customerName',
            sorter: (a: any, b: any) => {
                a = a.customerName == null ? '' : a.customerName
                b = b.customerName == null ? '' : b.customerName
                return a.localeCompare(b);
            },
            ...TableSearchComp('customerName', 'Customer Name'),
        },
        {
            title: 'Transaction By',
            dataIndex: 'backOfficeTransaction',
            key: 'backOfficeTransaction',
            align: "center",
            sorter: (a: any, b: any) => {
                if (a.backOfficeTransaction === b.backOfficeTransaction) {
                    return 0;
                } else if (a.backOfficeTransaction) {
                    return 1;
                } else {
                    return -1;
                }
            },
            render: (text: boolean) => (
                <>
                    {
                        !text ?
                            <Tag color="success">
                                Customer
                            </Tag> :
                            <Tag color="warning">
                                Back Office
                            </Tag>
                    }
                </>
            ),
            filters: [
                {
                    text: 'Customer',
                    value: false,
                },
                {
                    text: 'Back Office',
                    value: true,
                }
            ],
            onFilter: (value: string, record: any) => record.backOfficeTransaction === value,
        },

        {
            title: 'Request Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            sorter: (a: any, b: any) => {
                a = a.createdDate == null ? '' : a.createdDate
                b = b.createdDate == null ? '' : b.createdDate
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Started Date',
            dataIndex: 'startedDate',
            key: 'startedDate',
            sorter: (a: any, b: any) => {
                a = a.startedDate == null ? '' : a.startedDate
                b = b.startedDate == null ? '' : b.startedDate
                return a.localeCompare(b);
            },
            ...TableSearchComp('startedDate', 'Started Date'),
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD) : NOT_AVAILABLE}</span>
            )

        },
        {
            title: 'Process Date',
            dataIndex: 'processDate',
            key: 'processDate',
            sorter: (a: any, b: any) => {
                a = a.processDate == null ? '' : a.processDate
                b = b.processDate == null ? '' : b.processDate
                return a.localeCompare(b);
            },
            ...TableSearchComp('processDate', 'Process Date'),
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'API Status',
            dataIndex: 'apiResponseStatus',
            key: 'apiResponseStatus',
            align: "center",
            sorter: (a: any, b: any) => {
                a = a.apiResponseStatus == null ? '' : a.apiResponseStatus
                b = b.apiResponseStatus == null ? '' : b.apiResponseStatus
                return a.localeCompare(b);
            },
            filters: [
                {
                    text: API_RESPONSE_STATUS.PROCESSING,
                    value: API_RESPONSE_STATUS.PROCESSING,
                }, {
                    text: API_RESPONSE_STATUS.FAILED,
                    value: API_RESPONSE_STATUS.FAILED,
                },
            ],
            onFilter: (value: string, record: any) => record.apiResponseStatus.indexOf(value) === 0,
            render: (text: string, rec: any) => (
                <>
                    {
                        text === API_RESPONSE_STATUS.PENDING ?
                            <Tag color="warning">
                                {API_RESPONSE_STATUS.PENDING}
                            </Tag>
                            : text === API_RESPONSE_STATUS.PROCESSING ?
                                <Tag color="processing">
                                    {API_RESPONSE_STATUS.PROCESSING}
                                </Tag>
                                : text === API_RESPONSE_STATUS.FAILED ?
                                    <Tooltip placement="leftTop"
                                             title={getFailedMessages(rec.apiFailedReason)}>
                                        <Tag color="error">
                                            {API_RESPONSE_STATUS.FAILED}  <FontAwesomeIcon icon={faEnvelope}/>

                                        </Tag>
                                    </Tooltip>
                                    :
                                    <Tag color="default">
                                        N/A
                                    </Tag>
                    }


                </>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (rec: AccountWiseFundDetailDto) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view '
                            onClick={() => showModal(rec)}
                            icon={<EyeOutlined/>}>View</Button>
                </Space>
            ),
        },
    ];

    const showModal = (rec: AccountWiseFundDetailDto) => {
        setFormData(rec)
    }

    const toFixed = (value: number | undefined): any => {
        if (undefined != value) {
            let val = value.toString();
            if (val.indexOf(".") != -1) {
                val = val.slice(0, (val.indexOf(".")) + 3);
            }
            val = (+val).toFixed(2);
            return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return "0.00";
    }
    const getFailedMessages = (data: string) => {
        if (null != data) {
            const errorList = data.split(';');

            return (
                <div>
                    <ul style={{padding: '0 10px 0 18px', width: '100%'}}>
                        {errorList.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul>
                </div>
            );
        }
    }

    const setFormData = (data: AccountWiseFundDetailDto) => {
        investForm.setFieldsValue({
            portfolioId: data.portfolioNumber,
            fund: data.fundName,
            amount: toFixed(Math.abs(data.fundAmount)),
            refNo: data.transactionRefNo,
            collectionBank: data.collectionBank

        })
        if (data.transactionDocumentId && data.transactionDocumentId != null) {
            loadDocument(data.transactionDocumentId, data.jobNumber, DOC_CODE_INVEST_TRANSACTION_DOCUMENT)

        }
        let modalData = {
            requestId: data.accountWiseFundId,
            portFolioNumber: data.portfolioNumber,
            portFolioId: data.portfolioId,
            cin: data.customerCin
        }

        setModalData(modalData);
        setApiResponseStatus(data.apiResponseStatus as string)
        setIsModalOpen(true)

    }
    const handleCancel = () => {
        investForm.resetFields()
        setInvestMoneyRequestDocument(null)
        setIsModalOpen(false);
    };


    const loadDocument = (documentDetailId: number, jobNumber: number, type: string) => {
        setSpinnerLoading(true)
        documentService.getUploadDocumentListByTypeAndUploadedDocId(jobNumber, documentDetailId, [type]).then(res => {
            if (res.data.status == 'SUCCESS') {
                setSpinnerLoading(false)
                setInvestMoneyRequestDocument(res.data.results[0].uploadDocumentDetailDto);
            }
            setSpinnerLoading(false)
        }, (reason) => {
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason);
        });
    }

    const cancelRequest = () => {

        modal.confirm({
            title: 'Confirm',
            className: 'confirm-dialog-box',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to cancel this request?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setLoading(true)
                setRejectReasonModalOpen(true)
            },
            onCancel() {
                setLoading(false)
            }
        });

    }
    const cancelRequestSubmit = (val: { rejectReason: string }) => {
        setRejectReasonModalOpen(false)

        const requestData = {
            transactionRejectReason: val.rejectReason,
            transactionStatus: "CANCELLED",
            transactionDetailsId: modalData.requestId,
            portfolioId: modalData.portFolioId,
            cin: modalData.cin
        } as AuthorizeTransactionDto


        transactionService.cancelInvestTransactions(requestData).then(() => {
            setLoading(false)
            message.success("Successfully cancelled")
            setIsModalOpen(false)
            fetchProcessingInvestRequests()


        }).catch((res) => {
            setLoading(false)
            setIsModalOpen(false)
            setRejectReasonModalOpen(false)
            ErrorHandler.handleError(res)
        })
    }
    const retryRequest = () => {

        modal.confirm({
            title: 'Confirm',
            className: 'confirm-dialog-box',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to retry this request?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setLoading(true)
                const requestData = {
                    transactionDetailsId: modalData.requestId,
                    portfolioId: modalData.portFolioId,
                    cin: modalData.cin
                } as AuthorizeTransactionDto


                transactionService.retryInvestTransactions(requestData).then(() => {
                    setLoading(false)
                    message.success("Successfully retried")
                    setIsModalOpen(false)
                    fetchProcessingInvestRequests()
                }).catch((res) => {
                    setLoading(false)
                    setIsModalOpen(false)
                    setRejectReasonModalOpen(false)
                    ErrorHandler.handleError(res)
                })
            },
            onCancel() {
                setLoading(false)
            }
        });
    }

    const openModal = (document: UploadedDocumentDetailDto | undefined) => {
        if (document) {
            setLoading(true)
            documentService.viewOriginalDocument(document.uploadDocumentDetailId.toString()).then(res => {
                if (res.data !== null) {
                    setPreviewOpen(true)
                    setIsModalOpen(false)
                    setDocURL(res.data.results)
                    setDocType(Validation.checkDocumentContentType(res.data.results))
                    setDocumentName(document.originalDocumentName)
                    setLoading(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                    setLoading(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setLoading(false)
            })
            return true;
        }

    };
    return (
        <>
            {/*<Spin spinning={isSpinnerLoading} tip="Loading" size="large">*/}

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'
                        style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <div className='header_icon header-icon-center'>
                            <FontAwesomeIcon
                                icon={faMoneyBillTransfer}/>
                        </div>
                         Processing Invest Requests
                    </h2>
                </Col>
            </Row>
            <Row gutter={[16, 16]} className='margin_top_20'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Table scroll={{x: 'max-content'}} dataSource={customerRequestList} columns={columns}
                           loading={isSpinnerLoading}/>
                    <Modal title={"Invest Money Request"} open={isModalOpen} footer={null}
                           onCancel={handleCancel}
                           width={800}
                           centered style={{top: 20, paddingBottom: 20}} className={'modal-body-scroll-only disabled-data-show-inputs-container'}>
                        <Spin spinning={isLoading}>
                            <Row gutter={[24, 12]} className={'form-item-mb-12 modal-body-scroll-only-main-row'}
                                 style={{marginTop: 18}}>
                                <Col span={24}>
                                    <Card title={"Invest Money"} size={'small'}>
                                        <Form
                                            className='form-input'
                                            layout={"vertical"}
                                            form={investForm}
                                            disabled
                                        >
                                            <Row gutter={[12, 0]}>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Form.Item
                                                        label="Portfolio ID"
                                                        name={'portfolioId'}>
                                                        <Input size={'large'}/>

                                                    </Form.Item>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Form.Item
                                                        label="Fund"
                                                        name={'fund'}>
                                                        <Input size={'large'}/>
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Form.Item
                                                        label="Amount"
                                                        name={'amount'}>
                                                        <Input size={'large'}/>
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Form.Item
                                                        label="Collection Bank"
                                                        name={'collectionBank'}>
                                                        <Input size={'large'}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Form.Item
                                                        label="Transaction Reference Number"
                                                        name={'refNo'}>
                                                        <Input size={'large'}/>
                                                    </Form.Item>
                                                </Col>
                                                {investMoneyRequestDocument ?
                                                    <Col span={24} style={{marginBottom: 16, paddingRight: 28}}>
                                                        <Form.Item className={'form-item-label-only'}
                                                                   label={"Invest Transaction Document"}>
                                                        </Form.Item>
                                                        <div className='utility_bill img-nic'>
                                                            <div className='utulity_bill_icon_div'>
                                                                <div className="img_div">
                                                                    <img src={investMoneyRequestDocument?.thumbB64}
                                                                         alt=""/>
                                                                </div>
                                                                <div className='name_div'>
                                                                    <h5>{investMoneyRequestDocument?.documentTypeName}</h5>
                                                                </div>
                                                            </div>
                                                            <Button className='doc-view-btn' disabled={false}
                                                                    onClick={() => openModal(investMoneyRequestDocument)}
                                                            ><EyeOutlined/></Button>
                                                        </div>
                                                    </Col> : <></>}
                                            </Row>
                                        </Form>
                                    </Card>
                                </Col>
                                {API_RESPONSE_STATUS.FAILED === apiResponseStatus ?
                                    <>
                                        <Col span={24}>
                                            <Divider style={{marginBottom: 12}}></Divider>
                                        </Col>

                                        <Col span={24} className={'request-auth-modal-btns-row'}>

                                            <Space style={{float: 'right'}}>

                                                <Button danger onClick={cancelRequest}
                                                        style={{
                                                            width: 100,
                                                            marginRight: 8
                                                        }}><StopOutlined/> Cancel</Button>
                                                <Button type="success" onClick={retryRequest}
                                                        style={{
                                                            width: 100,
                                                            background: "#008d86",
                                                            color: "white",
                                                        }}><RedoOutlined/> Retry</Button>
                                            </Space>
                                        </Col>
                                    </> : <></>
                                }
                            </Row>
                        </Spin>


                    </Modal>
                    <Modal title={`Cancel Reason`}
                           open={isRejectReasonModalOpen}
                           destroyOnClose={true}
                           maskClosable={false}
                           footer={null}
                           onCancel={handleRejectReasonCancel}
                    >
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form
                                    layout={"vertical"}
                                    initialValues={{remember: true}}
                                    onFinish={cancelRequestSubmit}
                                >
                                    <Form.Item
                                        name={"rejectReason"}
                                        label={`Cancel Reason`}
                                        rules={[{
                                            required: true,
                                            message: `Please enter cancel reason`
                                        }]}>
                                        <TextArea showCount placeholder={`Please enter cancel reason`}
                                                  maxLength={255}
                                                  bordered={true}/>
                                    </Form.Item>
                                    <Form.Item>
                                        <Space style={{float: 'right'}}>
                                            <Button onClick={handleRejectReasonCancel}>
                                                Cancel
                                            </Button>
                                            <Button htmlType="submit"
                                                    type="primary">
                                                Submit
                                            </Button>
                                        </Space>
                                    </Form.Item>


                                </Form>
                            </Col>
                        </Row>

                    </Modal>
                    <Modal
                        className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                        open={previewOpen}
                        centered
                        title={documentName}
                        onCancel={handlePreviewCancel}
                        destroyOnClose={true}
                        width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                        footer={[
                            <Button type="primary" icon={<DownloadOutlined/>}
                                    style={{background: '#FF7400', height: 40}}
                                    htmlType="submit" onClick={() => download(docURL, documentName)}>
                                Download
                            </Button>]}>
                        <PreviewModalComp docURL={docURL}/>
                    </Modal>

                </Col>
            </Row>
            {/*</Spin>*/}
        </>


    )
}
export default InvestRetryRequestList